/**
 * Moves the Kiwi Size Chart Recommender app block's DOM node to sit inline
 * with the variant picker (as the first child of .product__form__outer,
 * before <variant-selects>), instead of its normal position several blocks
 * away as a sibling of .product__form__holder — see assets/theme.css for
 * why this can't be done with flexbox `order` alone.
 *
 * Kiwi's markup is server-rendered by Shopify's app-block system, so it's
 * already present at DOMContentLoaded; this only reparents it, it doesn't
 * wait on Kiwi's own async widget script.
 */
(function () {
  function moveKiwiBlock(holder) {
    var outer = holder.querySelector('.product__form__outer');
    if (!outer) return;

    var sibling = holder.nextElementSibling;
    while (sibling) {
      if (sibling.classList.contains('shopify-app-block') && sibling.querySelector('.ks-container-app-block')) {
        outer.insertBefore(sibling, outer.firstChild);
        return;
      }
      sibling = sibling.nextElementSibling;
    }
  }

  function init() {
    document.querySelectorAll('.product__form__holder').forEach(moveKiwiBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
